import React, { useEffect, useState } from 'react'
import './WebsiteContentSection.css'
import { AnimatePresence, motion } from 'framer-motion'
import { backdropTransition, transitionDuration } from '../../../../Util/PageTransitions'
import WarningDialogue from '../../../../Util/WarningDialogue'
import SectionItem from './WebsiteContent/SectionItem';

export default function WebsiteContentSection(props) {
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({});

  const isDeleteItem = (flag, type) => {
    props.isDelete(flag,type);
  }
  
  return <>
    <div className='adminMenuSectionContainer'>
      <AnimatePresence exitBeforeEnter>
        <motion.div className='modifyAdminMenuSectionTitleContainer' key='sdiofhjw02ejr0' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
          <div className="admin-main-category-head">
            <h1 className='adminMenuSectionTitle'>{props.sectionTitle}</h1>
          </div>
        </motion.div>
      </AnimatePresence>
      <div className={`adminMenuItemsContainer adminMenuItemsContainer-website  ${props.sectionId === 1 ? 'home-slider-grid' : props.sectionId === 4 ? 'home-slider-grid' : ''}`}>
        {props && props.data && props.data.length ? props?.data?.map((value, index) => (
          <SectionItem itemDetails={value} itemDelete={isDeleteItem} sectionId={props.sectionId} key={index} setItemDisplay={props.setItemDisplay} viewItemDetails={props.viewItemDetails} />
        )) : ''}
        {!(props.sectionId === 4 && props.data?.length > 0) && <div className='addnew-item-block' onMouseDown={() => props.setItemDisplay(undefined, props.sectionId, true)}>
          <div className="box-content-item">
            <div className="addsign"><span>+</span></div>
            <h2 className='adminMenuItemTitle'>Add New Item</h2>
            <p className='adminMenuItemDescription'>Add a new item to {props.sectionTitle}</p>
          </div>
        </div>}
      </div>
    </div >
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}